export const translatedAnswers: Record<string, Record<string, string>> = {
    reporting_c: {
        Tjänst: 'service',
        Produkt: 'product',
    },
    area_c: {
        'E-handel': 'ehandel',
        Bank: 'bank',
        'Elektronisk kommunikation': 'electric',
    },
    category_service_c: {
        Webbsida: 'website',
        App: 'app',
    },
    category_product_c: {
        Dator: 'computer',
        Mobiltelefon: 'cellphone',
        Surfplatta: 'tablet',
        Läsplatta: 'reading_tablet',
        'Annan utrustning för att komma åt kommunikationstjänster': 'other_comm',
        'Annan utrustning för att komma åt medietjänster': 'other_media',
        Betalterminal: 'aetm',
        Automat: 'automat',
        'Interaktiv självbetjäningsterminal': 'interactive_self_service_terminal',
    },
    issue_type_c: {
        'Åberopande av undantag från tillgänglighetskrav enligt 8 § LPTT': 'aberopande',
        'Underrättelse om tillgänglighetsbrister enligt 21 eller 24 §§ LPTT': 'tillganglighet',
    },
    sekretess_c: {
        Ja: 'yes',
        Nej: 'no',
        'Vet ej': 'dont_know',
    },
    received_extern_c: {
        Ja: 'yes',
        Nej: 'no',
        'Vet ej': 'dont_know',
    },
    verified_c: {
        true: '1',
        false: '0',
    },
}

export const specialMappedQuestions = new Set(['motivering_multi_c'])
